import { useTranslation } from 'react-i18next';
import { useLabel } from '@platform/hooks/useLabel';
import { cx } from '@platform/core/lib/cx';
import { workspaceType } from '@platform/navigation';
import { initials } from '../initials';
import { useWorkspaceCounts } from '../useWorkspaceCounts';
import type { IWorkspaceCardProps } from './IWorkspaceCardProps';

/**
 * Картка робочого простору (прототип v4 G:L3640): плитка 32px кольору типу з ініціалами, назва 600 з «…», тип 12px, «Поточний» (акцент),
 * «N учасників · M модулів · Ви: роль», кнопка «Відкрити» (поточний) або «Перемкнути»; поточний — рамка й тло --accent-soft.
 */
export function WorkspaceCard({ workspace, current, onOpen }: IWorkspaceCardProps) {
  const { t } = useTranslation();
  const label = useLabel();
  const counts = useWorkspaceCounts(workspace.id, workspace.type === 'parliament');
  const type = workspaceType(workspace.type);
  const meta = [counts.members !== undefined && t('shell.members', { count: counts.members }), counts.modules !== undefined && t('shell.modulesCount', { count: counts.modules }),
    t('wsNavigator.you', { role: t(`roles.${workspace.myRole}`, { defaultValue: workspace.myRole }) })].filter(Boolean).join(' · ');
  return (
    <div className={cx('wn-card', current && 'is-current')}>
      <div className="wn-card__top">
        <span className="wn-card__tile" style={{ background: type.tone }} aria-hidden="true">{initials(workspace.name)}</span>
        <span className="wn-card__titles"><span className="wn-card__name" title={workspace.name}>{workspace.name}</span><span className="wn-card__type">{label(type.label)}</span></span>
        {current && <span className="wn-card__current">{t('wsNavigator.current')}</span>}
      </div>
      <span className="wn-card__meta">{meta}</span>
      <button type="button" className="wn-card__btn" onClick={() => onOpen(workspace.id)}>{current ? t('wsNavigator.open') : t('wsNavigator.switch')}</button>
    </div>
  );
}
